import { render, staticRenderFns } from "./PalpatePulseAction.vue?vue&type=template&id=11b08a9e&scoped=true&"
import script from "./PalpatePulseAction.vue?vue&type=script&lang=js&"
export * from "./PalpatePulseAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b08a9e",
  null
  
)

export default component.exports